import React, { useContext } from "react";

// Context
import AppContext from "./AppContext";

// Css
import "./DoneToggle.css";

// Material Ui
// #Element
import IconButton from "@material-ui/core/IconButton";
// #Icons
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// #Transitions
import Zoom from "@material-ui/core/Zoom";

function DoneToggle() {
  const { appContext, setAppContext } = useContext(AppContext);
  const { hasContent, textFocus, toolBarOn } = appContext;

  const doneButton = (
    <CheckCircleIcon style={{ fontSize: 45, color: "#ea5455" }} />
  );
  const editButton = <EditIcon style={{ fontSize: 40, color: "#1a1c20" }} />;

  const toggleHandle = () => {
    setAppContext((prev) => ({
      ...prev,
      toolBarOn: !toolBarOn,
    }));
  };

  return (
    <>
      <Zoom
        in={hasContent && !textFocus}
        style={{ transitionDuration: "0.8s" }}
      >
        <div className="toolbar__done">
          <IconButton onClick={toggleHandle}>
            {toolBarOn ? doneButton : editButton}
          </IconButton>
        </div>
      </Zoom>
    </>
  );
}

export default DoneToggle;
